import { FlexCrate } from '@perch-labs/shrike';
import { Chart as ChartJS, ArcElement, Tooltip } from 'chart.js';
import { Pie } from 'react-chartjs-2';
import { ComponentProps } from 'react';

ChartJS.register(ArcElement, Tooltip);

export type PieChartProps = ComponentProps<typeof Pie> & { height?: string };

export const PieChart = (props: PieChartProps) => (
  <FlexCrate
    justifyContent="center"
    margin="0 auto"
    height={props.height || '150px'}
  >
    <Pie {...props} />
  </FlexCrate>
);
